import { useEffect } from 'react';
import { callDeepLink } from '@croquiscom/web2app';

import { useAppConfig } from '@common/app-config';
import { useOnceReveal } from '@common/hooks';
import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

import { useCrossSellerProductUBL } from '../log/useCrossSellerProductUBL';

export const useCrossSellerProductService = () => {
  const { isZigzagApp } = useAppConfig();
  const { targetRef, isRevealed } = useOnceReveal();
  const { impressCrossSellerProductUBL, clickCrossSellerProductUBL } = useCrossSellerProductUBL();
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);

  useEffect(() => {
    if (isRevealed) {
      impressCrossSellerProductUBL();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRevealed]);

  const handleClick = () => {
    clickCrossSellerProductUBL();
    const url = `${window.location.origin}/products/cross-seller-product/${param.catalog_product_id}`;
    if (isZigzagApp) {
      callDeepLink('/simple_browser')({
        url: encodeURIComponent(url),
      });
    } else {
      window.location.assign(url);
    }
  };

  return { targetRef, cross_seller_product_count: product.cross_seller_product_count ?? 0, handleClick };
};
